import {
  Component,
  Input,
  OnDestroy,
  Inject,
  NgZone,
  ViewEncapsulation
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import {AnimationOptions} from 'ngx-lottie';
import {AnimationItem} from 'lottie-web';
@Component({
  selector: 'app-spinner',
  template: `<div class="preloader d-flex justify-content-between align-items-center" *ngIf="isSpinnerVisible">
    <ng-lottie class="d-flex justify-content-between m-auto" [options]="options" (animationCreated)="animationCreated($event)" height="215px" width="150px"></ng-lottie>
  </div>`,
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
  options: AnimationOptions = {
    path: '/assets/animations/logo_loader_a_orange.json',
  };
  public isSpinnerVisible = true;
  @Input() public backgroundColor = 'rgba(0, 115, 170, 0.69)';

  constructor(
    private router: Router,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationStart) {
          this.isSpinnerVisible = true;
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.isSpinnerVisible = false;
        }
      },
      () => {
        this.isSpinnerVisible = false;
      }
    );
  }


  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}
